import { apiRequest, createAPIModule, queryString } from '@/api/utils';

const endpoint = 'encargos';

export default {
  ...createAPIModule({
    endpoint,
    getAllParams: ({
      code,
      filterStatus,
      filterValtin,
      filterBranch,
      filterLoanNumber,
      filterApplicantName,
      filterRegistro,
      filterFinca,
      filterCadastralReference,
      filterFinalidad,
      filterDireccion,
      filterDelegationName,
      filterApplicantNif,
      filterCliente,
      filterParalizados,
      filterExpediente,
      from,
      include,
      page,
      perPage,
      search,
      to,
      incidencia,
      filterPoblacion,
      fFrom,
      fTo,
      eFrom,
      eTo,
      vTo,
      vFrom,
      sort,
    }) => ({
      'filter[encargos.estado]': filterStatus,
      'filter[numero_encargo]': search,
      'filter[codigo]': code,
      'filter[num_valoracion]': filterValtin,
      'filter[sucursal.sucursal]': filterBranch,
      'filter[num_prestamo]': filterLoanNumber,
      'filter[solicitante.nombre]': filterApplicantName,
      'filter[solicitante.nif]': filterApplicantNif,
      'filter[inmueble_direccion]': filterDireccion,
      'filter[registro_nombre]': filterRegistro,
      'filter[registro_finca]': filterFinca,
      'filter[registro_refcatastral]': filterCadastralReference,
      'filter[delegacion.nombre]': filterDelegationName,
      'filter[from]': from,
      'filter[incidencias]': incidencia,
      'filter[inmueble_finalidad]': filterFinalidad,
      'filter[inmueble_poblacion]': filterPoblacion,
      'filter[empresa_cliente.clave]': filterCliente,
      'filter[entrega_from]': eFrom,
      'filter[entrega_to]': eTo,
      'filter[paralizado]': filterParalizados,
      'filter[to]': to,
      'filter[f_from]': fFrom,
      'filter[f_to]': fTo,
      'filter[v_from]': vFrom,
      'filter[v_to]': vTo,
      'filter[expediente]': filterExpediente,
      include,
      page,
      per_page: perPage,
      sort,
    }),
  }),


  assignAssessor: ({ chargeIds, assessorId }) =>
    apiRequest.post(`${endpoint}/asignarTasador`, [{
      encargos: chargeIds,
      tasador: assessorId,
    }]),

  assignAssessorToExit: ({ chargeIds, assessorId }) =>
    apiRequest.post(`${endpoint}/asignarTasadorAsignacionDeSalida`, [{
      encargos: chargeIds,
      tasador: assessorId,
    }]),
  assignAssessorToRevision: ({ chargeIds, assessorId }) =>
    apiRequest.post(`${endpoint}/asignarTasadorAsignacionDeRevision`, [{
      encargos: chargeIds,
      tasador: assessorId,
    }]),

  changeStatus: ({ id, status }) => apiRequest.post(`${endpoint}/estado/${id}`, { estado: status }),

  moveToBWithValidation: chargeIds =>
    apiRequest.post(`${endpoint}/movetobwithvalidation`, { encargos: chargeIds }),

  getAllUnscheduled({
    assessorId,
    include,
    page,
    perPage,
    search,
  } = {}) {
    const params = {
      'filter[numero_encargo]': search,
      include,
      page,
      per_page: perPage,
    };

    return apiRequest.get(`${endpoint}/noAgendados/${assessorId}?${queryString.stringify(params)}`);
  },

  getAnulados({
    sort,
    page,
    perPage,
    search,
  } = {}) {
    const params = {
      'filter[numero_encargo]': search,
      page,
      per_page: perPage,
      sort,
    };

    return apiRequest.get(`${endpoint}/anulados?${queryString.stringify(params)}`);
  },

  unassignAssessor: chargeIds =>
    apiRequest.post(`${endpoint}/desasignarTasador`, [{ encargos: chargeIds }]),

  unassignAssessorFromExit: chargeIds =>
    apiRequest.post(`${endpoint}/desasignarTasadorSalida`, [{ encargos: chargeIds }]),

  getStatusCounts({
    paralizados,
  } = {}) {
    const params = {
      'filter[paralizado]': paralizados,
    };

    return apiRequest.get(`${endpoint}/numeros?${queryString.stringify(params)}`);
  },

  getAllForVisitStatusWithoutPending({
    assessorId,
    include,
    page,
    perPage,
    search,
  } = {}) {
    const params = {
      'filter[numero_encargo]': search,
      include,
      page,
      per_page: perPage,
    };

    return apiRequest.get(`${endpoint}/enEstadoVisitasSinVisitasPendientes/${assessorId}?${queryString.stringify(params)}`);
  },

  unassignVisits: ids =>
    apiRequest.post(`${endpoint}/desagendarVisitas`, {
      encargos: ids,
    }),

  autoCodigosPostales: codigo =>
    apiRequest.get(`codigospostales/${codigo}`),

  autoCodigosVersion2: codigo  => 
    apiRequest.get(`codigos-postales/auto/${codigo}`),

  copyCharge: id =>
    apiRequest.post(`${endpoint}/copy`, {
      encargo: id,
    }),


};
